var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-title",class:{ hasMargin: _vm.hasMargin }},[_c('span',[_vm._v(" "+_vm._s(_vm.content))]),_vm._t("default"),_c('span',{staticClass:"text"},[_vm._t("text")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }